import React from 'react';
import working from './img/working.png'
import api from './apiConnector'

export default class RightButtons extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            sendingEmail:false,
            waiting:false
        }
    }


    sendDevisEmail() {
        this.setState({sendingEmail:true})
        this.props.container.sendDevisEmail(this.gotEmail.bind(this))
    }


    gotEmail() {
        this.setState({sendingEmail:false})
    }


    duplicateDevis() {
        api.post(
            {   action:'dup_devis',
                id:this.props.devis.typedId()
            },()=>{
                this.props.container.props.container.initialLoad()
            }
        )
    }


    resync() {
        if ( !this.state.waiting ) {
            this.setState({waiting:true})
            const me = this
            api.post({
                action:'get_devis',
                resync:true, // This forces re-synchronization : calculates prices by contacting xenassur
                id:this.props.devis.typedId()
            },
            ()=>{
                me.setState({waiting:false})
            })
        }
    }


    render() {
        const {devis,api} = this.props
        const {params} = devis

        const emailButtonClass = 'button'+(this.state.sendingEmail?' disabled':'')
        const emailButton = ( this.props.devis.params.email&&this.props.devis.synchronized ) ? 
        <a className={emailButtonClass} onClick={this.sendDevisEmail.bind(this)}>Envoyer le devis à <br/>{this.props.devis.params.email}</a>
        : ''

        let adminButtons = []
        adminButtons.push(
            <a target="_blank" key="logs_tarifs" className="button" href={
                api.downloadTypeLogs(devis._id.$oid,'xena_tarifs')
            }>Logs tarifs</a>
        )
        if ( params.nom ) {
            adminButtons.push(
                <a target="_blank" key="logs_devis" className="button" href={
                    api.downloadTypeLogs(devis._id.$oid,'xena_devis')
                }>Logs devis</a>
            )    
            adminButtons.push(
                <a target="_blank" key="logs_axa_devis" className="button" href={
                    api.downloadTypeLogs(devis._id.$oid,'axa_devis')
                }>Logs AXA devis</a>
            )    
        }

        adminButtons.push(
            <a target="_blank" key="logs_fma_tarifs" className="button" href={
                api.downloadTypeLogs(devis._id.$oid,'fma_tarifs')
            }>Logs FMA tarifs</a>
        )    
        if ( params.nom ) {
            adminButtons.push(
                <a target="_blank" key="logs_fma_enregistrement" className="button" href={
                    api.downloadTypeLogs(devis._id.$oid,'fma_enregistrement')
                }>Logs FMA enregistrement</a>
            )
            adminButtons.push(
                <a target="_blank" key="logs_fma_souscription" className="button" href={
                    api.downloadTypeLogs(devis._id.$oid,'fma_subscription')
                }>Logs FMA souscription</a>
            )
        }

        if ( this.props.devis.status != 'ongoing' ) {
            adminButtons.push(
                <a target="_blank" key="logs_screenshots" className="button" href={api.downloadLogs(this.props.devis.typedId(),'logs_subscribe')}>Logs souscription</a>
            )
        }
        if ( devis.getMaxance().hasAnything() ) {
            adminButtons.push(
                <a target="_blank" key="logs_maxance" className="button" href={api.downloadTypeLogs(this.props.devis._id.$oid,'maxance_tarifs')}>Logs Maxance Tarifs</a>
            )    
        }
        adminButtons.push(
            <a target="_blank" key="logs_documents" className="button" href={api.downloadTypeLogs(this.props.devis._id.$oid,'xena_documents')}>Logs récupération documents</a>
        )    

        return <div className="details_section_button">
    
            {emailButton}
            { this.props.devis.synchronized 
                    ? <a className="button" href={api.downloadDevisUrl(this.props.devis.typedId())}>Télécharger le devis Xenassur</a>
                    : <><img className="working" src={working}/>Devis en cours de modification. <a className={this.state.waiting?'button disabled':'button'} onClick={this.resync.bind(this)}>Recalculer le devis</a></> }
            <a className="button" onClick={this.duplicateDevis.bind(this)}>Dupliquer ce devis</a>

            {adminButtons}

        </div>
    }
}
